

















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { HsabSsoDestination } from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    SsoDeepLink,
  }
})
export default class HsabLinkedAccounts extends Vue {
  hsabAccountStore = useHsabAccountsStore();

  get hsabBankingCardsDeeplinkLocation () {
    return HsabSsoDestination.BankingCards;
  }

  get headerCopy () {
    return this.hsabAccountStore.debitCardsAvailable ?
      "Your Linked Accounts and Debit Cards" :
      "Your Linked Accounts";
  }

  get bodyCopy () {
    return this.hsabAccountStore.debitCardsAvailable ?
      "View and manage your linked bank accounts and debit cards" :
      "View and manage your linked bank accounts";
  }
}
